function ClearCart(){
 $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      localtion.reload();
    },
    dataType: 'json'
  }); 
}

$(document).ready(function () {
	$('.custom__cart_remove').click(function () {
	  var itemKeyValues = $(this).attr('data-cartkey');
	  var keyArr=itemKeyValues.split(",");
	  var data = [];
	  for (i = 0; i < keyArr.length; i++) {
		  if(keyArr[i]!=""){
			data[keyArr[i]]=0;
		  }
	  }
	  data=Object.assign({}, data); 
	   var upddata = {
		"updates": data
	  };

		$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		data: upddata,
		dataType: 'json',
		success: function () {
		  location.reload();
		}
	  });  
	});
	$('.cart_pageQuantity').change(function () {
	  var qty = $(this).val();
	 var itemKeyValues = $(this).attr('data-key');
	  var data = [];
	   data[itemKeyValues] = qty;

	  data=Object.assign({}, data); 
	   var upddata = {
		"updates": data
	  };

		$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		data: upddata,
		dataType: 'json',
		success: function () {
		  location.reload();
		}
	  });  
	});	
	/* items active  */
	$('.lsg-bundle-product-select-top-content').click(function () {
	 $(this).closest('.lsg-bundle-product-select-wrapper').toggleClass("hasActive");
	});
});

/* custom maths functions */
function getTheDiscountedPrice(numVal1,numVal2) {         
 var totalValue = numVal1 * ( (100-numVal2) / 100 );
 return Math.round(totalValue * 100) / 100;
}

function getProgressPercentage(mainValue,currValue) {         
 var totalValue = currValue *  (100/mainValue);
 return Math.round(totalValue * 100) / 100;
}

//bundle_offer__value
function update__bundle_offer__value(planid=null,maxqty=0){
	if(planid==null){
		jQuery('.lsg-bundle-interval-frequency-select:checked').each(function(index, value) {
			var $this=jQuery(this);
			  var curr__pid=$this.attr("data-prdid");
			  var curr__price=$this.attr("data-price");
			  var currentDiscount=$this.attr("data-discount-value");
				var currentDiscountType=$this.attr("data-discount-type");
				if(currentDiscountType=="percentage"){
					var curr__price=curr__price-(curr__price*(currentDiscount/100));
					var offerHtml=Shopify.formatMoney(Math.round(curr__price)*maxqty)+`<span class="offer__saves">Save `+currentDiscount+`%</span>`;
				}else{
					var offerHtml=Shopify.formatMoney(Math.round((curr__price-currentDiscount))*maxqty)+` <span class="offer__saves">Save `+Shopify.formatMoney(currentDiscount*maxqty)+`</span>`;

				}
				jQuery('.lsg-bundle-size-select-el[data-bundle-index="'+curr__pid+'"] .btn-top-description .bundle_offer__value').html(offerHtml);
				
		});
	}else{
		var $this=jQuery('.lsg-bundle-interval-frequency-select[value="'+planid+'"]');
			  var curr__pid=$this.attr("data-prdid");
			  var curr__price=$this.attr("data-price");
			  var currentDiscount=$this.attr("data-discount-value");
				var currentDiscountType=$this.attr("data-discount-type");
				if(currentDiscountType=="percentage"){
					var curr__price=curr__price-(curr__price*(currentDiscount/100));
					var offerHtml=Shopify.formatMoney(Math.round(curr__price)*maxqty)+`<span class="offer__saves">Save `+currentDiscount+`%</span>`;
				}else{
					var offerHtml=Shopify.formatMoney(Math.round((curr__price-currentDiscount))*maxqty)+` <span class="offer__saves">Save `+Shopify.formatMoney(currentDiscount*maxqty)+`</span>`;

				}
				jQuery('.lsg-bundle-size-select-el[data-bundle-index="'+curr__pid+'"] .btn-top-description .bundle_offer__value').html(offerHtml);
	}
}

$(document).ready(function () {
	$('.lsg-bundle-size-select-el').click(function () {
		$('.lsg-bundle-size-select-el').removeClass("lsg-bundle-size-select-el--selected");
		$(this).addClass("lsg-bundle-size-select-el--selected");
		  var prdid = $(this).attr('data-bundle-index');
		$('.lsg-bundle-block').removeClass("lsg-bundle-block-active");
		$('.lsg-bundle-block[data-bundle-product="'+prdid+'"]').addClass("lsg-bundle-block-active");

	});
});
